export const environment = {
    production: false,
    stage: 'dev',
};
